export default function startUrlWatcher() {
  function urlChanged() {
    const object = { event: `Visited page`, extra: { url: location.href } }
    const json = JSON.stringify(object)
    const payload = btoa(json)
    fetch(`/user-event?e=${payload}`, {
      credentials: 'same-origin',
      cache: 'no-cache',
      redirect: 'manual',
    })
  }

  let currentUrl = null

  setInterval(() => {
    if (location.href !== currentUrl) {
      currentUrl = location.href
      urlChanged()
    }
  }, 500)
}
